module.exports = require('./prototype-shims')
